var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18784 1.89844C6.55114 1.89844 6.88584 2.09545 7.06214 2.41307L8.28539 4.61647C8.44554 4.90497 8.45304 5.25392 8.30549 5.54907L7.12709 7.90587C7.12709 7.90587 7.46859 9.66162 8.89779 11.0908C10.327 12.52 12.0768 12.8556 12.0768 12.8556L14.4333 11.6774C14.7286 11.5297 15.0778 11.5374 15.3664 11.6978L17.5761 12.9263C17.8934 13.1027 18.0902 13.4373 18.0902 13.8003V16.3371C18.0902 17.6289 16.8902 18.562 15.6662 18.1489C13.1522 17.3007 9.24989 15.6856 6.77649 13.2121C4.30304 10.7387 2.68794 6.83637 1.83967 4.32242C1.42666 3.09837 2.35971 1.89844 3.65153 1.89844H6.18784Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.cc79c61660aad5df6e94b72dd4450495.svg";
export { ForwardRef as ReactComponent };